export const generatedSourceQueryCustodyLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-source-query-custody-ledger",
  "operatingRule": "This ledger records legally and scientifically reviewable query contracts. It is not raw provider custody, not a live refresh, and not a source-promotion artifact.",
  "queryCount": 34,
  "sourceCount": 33,
  "registrySourceCount": 33,
  "custodyCoverageComplete": true,
  "missingSourceIds": [],
  "detailedQueryCount": 9,
  "registryDerivedQueryCount": 25,
  "liveFetchCount": 0,
  "reviewCandidateCount": 0,
  "promotionAllowed": false,
  "evidenceHashes": {
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "sourceIngestionLedger": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
    "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02"
  },
  "requiredPromotionArtifacts": [
    "raw provider response hash",
    "normalized parser output hash",
    "query echo or request metadata",
    "capture timestamp",
    "license or terms review",
    "units map",
    "uncertainty map",
    "fixture or tolerance test",
    "reviewer approval"
  ],
  "globalPromotionBoundary": "No query custody record can verify a scientific, resource, trajectory, economic, or business conclusion until a reviewed payload passes source-ingestion validation.",
  "queryRecords": [
    {
      "id": "query-horizons-mercury-object-record",
      "sourceId": "horizons-api",
      "sourceTitle": "JPL Horizons API",
      "provider": "NASA/JPL Horizons",
      "endpoint": "https://ssd.jpl.nasa.gov/api/horizons.api",
      "method": "GET",
      "params": {
        "format": "json",
        "COMMAND": "'199'",
        "OBJ_DATA": "'YES'",
        "MAKE_EPHEM": "'NO'"
      },
      "expectedResponseType": "json",
      "sourceRecordHash": "fnv1a32-9335c241",
      "workOrderId": "source-ingest-horizons-api",
      "workOrderHash": "sha256-87c8e4bb328d92196995c2a99ceb331d2f9e3c6616f90eb5b75f48e3a1e8af10",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "body-physical-and-orbit-metadata",
        "requiredFields": [
          "signature",
          "result",
          "queryEcho",
          "targetBody"
        ],
        "blockedIfMissing": [
          "source response hash",
          "query echo",
          "capture timestamp"
        ]
      },
      "unitsMap": {
        "targetBody": "NAIF integer id/name",
        "orbitMetadata": "provider text with units preserved"
      },
      "uncertaintyMap": {
        "objectRecord": "Provider metadata; not an ephemeris tolerance record."
      },
      "licenseOrTermsNote": "NASA/JPL public API query metadata may be recorded; raw response redistribution still requires review before promotion.",
      "fixtureOrTolerancePlan": "Compare fetched response hash, query echo, and target identity against reviewed deterministic snapshot expectations.",
      "promotionBoundary": "Custody record only; does not promote trajectory, conjunction, thermal, or business claims.",
      "rateLimitOrAccessNote": "Public API; keep refresh jobs snapshot-first and reviewed before browser publication.",
      "queryHash": "sha256-f466d56ecbd487c3c193fe148d3cfb15b4e7ec1383bef83bfcada6394b50e3ed",
      "recordHash": "sha256-70351cf58a8955ca12664127f995f53fe503022f8781595200f1a3a92411d321"
    },
    {
      "id": "query-horizons-earth-mercury-geometry",
      "sourceId": "horizons-api",
      "sourceTitle": "JPL Horizons API",
      "provider": "NASA/JPL Horizons",
      "endpoint": "https://ssd.jpl.nasa.gov/api/horizons.api",
      "method": "GET",
      "params": {
        "format": "json",
        "COMMAND": "'199'",
        "CENTER": "'500@399'",
        "MAKE_EPHEM": "'YES'",
        "EPHEM_TYPE": "'OBSERVER'",
        "START_TIME": "'2026-Jan-01'",
        "STOP_TIME": "'2026-Dec-31'",
        "STEP_SIZE": "'30 d'",
        "QUANTITIES": "'20,23,24'",
        "TIME_TYPE": "'TDB'"
      },
      "expectedResponseType": "json",
      "sourceRecordHash": "fnv1a32-9335c241",
      "workOrderId": "source-ingest-horizons-api",
      "workOrderHash": "sha256-87c8e4bb328d92196995c2a99ceb331d2f9e3c6616f90eb5b75f48e3a1e8af10",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "earth-mercury-distance-light-time-elongation-series",
        "requiredFields": [
          "epochTdb",
          "deltaAu",
          "lightTimeMinutes",
          "solarElongationDeg"
        ],
        "blockedIfMissing": [
          "time scale",
          "distance unit",
          "light-time unit",
          "elongation unit"
        ]
      },
      "unitsMap": {
        "epoch": "TDB",
        "delta": "AU",
        "lightTime": "minutes",
        "elongation": "degrees"
      },
      "uncertaintyMap": {
        "distanceAu": "Parser tolerance must be declared per snapshot.",
        "lightTimeMinutes": "Derived from source distance or provider field; tolerance required.",
        "elongationDeg": "Provider geometry quantity; tolerance required."
      },
      "licenseOrTermsNote": "NASA/JPL public API; committed beta data remains reviewed snapshot output, not unreviewed live response text.",
      "fixtureOrTolerancePlan": "Validate AU-to-km and light-time outputs against deterministic Horizons snapshot tolerances.",
      "promotionBoundary": "May support source refresh candidates only; operational contact windows require SPICE GF or independent validation artifact.",
      "rateLimitOrAccessNote": "Batch refresh no more than scheduled review cadence; persist query and response hashes.",
      "queryHash": "sha256-3c6b3a6f0e557e81bee39f57058f69eed09820a1250866c0b70e31bcdeae3bf5",
      "recordHash": "sha256-e4a036ad404d37a49d4b1bf1bddfc25f2cd32ce45d5bc08b41152f0eb9c2b1f6"
    },
    {
      "id": "query-sbdb-asteroid-record-screen",
      "sourceId": "sbdb-api",
      "sourceTitle": "JPL Small-Body Database API",
      "provider": "NASA/JPL Small-Body Database",
      "endpoint": "https://ssd-api.jpl.nasa.gov/sbdb.api",
      "method": "GET",
      "params": {
        "des": "example-candidate-designation",
        "phys_par": "true",
        "close_approach": "true",
        "covariance": "mat"
      },
      "expectedResponseType": "json",
      "sourceRecordHash": "fnv1a32-93c0fe91",
      "workOrderId": "source-ingest-sbdb-api",
      "workOrderHash": "sha256-03df633e2ee73cac09d65f2a2f5428e468e6ac89008e3f4378d6c8fd575ca8a5",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "candidate-orbit-and-physical-property-record",
        "requiredFields": [
          "objectFullName",
          "orbitClass",
          "conditionCode",
          "diameterOrH",
          "solutionDate"
        ],
        "blockedIfMissing": [
          "object-level source record",
          "orbit uncertainty",
          "physical property provenance"
        ]
      },
      "unitsMap": {
        "diameter": "km or m as provider states",
        "absoluteMagnitudeH": "mag",
        "orbitConditionCode": "dimensionless code",
        "vInfinity": "km/s when present"
      },
      "uncertaintyMap": {
        "diameter": "Provider uncertainty or unknown.",
        "orbit": "Orbit condition code and covariance status.",
        "resourceComposition": "Unknown unless linked to taxonomy, spectra, or mission evidence."
      },
      "licenseOrTermsNote": "NASA/JPL public source metadata may be captured after review; resource classifications stay blocked without independent evidence.",
      "fixtureOrTolerancePlan": "Candidate parser must prove missing composition remains unknown and cannot become a verified resource claim.",
      "promotionBoundary": "Screening metadata only; no asteroid resource-composition or extractability claim.",
      "rateLimitOrAccessNote": "Object-level refreshes should be reviewed and batched by candidate set.",
      "queryHash": "sha256-06222352a14f2aa3df3d8007b9c4538c7d38c0d5740f734b9b7e091f9ff0d5ab",
      "recordHash": "sha256-f7194dba35e8e1bd43a2f9726b9e33e891a729040850de60d14f1e8f1275fead"
    },
    {
      "id": "query-cad-2026-close-approach-screen",
      "sourceId": "cad-api",
      "sourceTitle": "SBDB Close Approach Data API",
      "provider": "NASA/JPL CNEOS CAD",
      "endpoint": "https://ssd-api.jpl.nasa.gov/cad.api",
      "method": "GET",
      "params": {
        "date-min": "2026-01-01",
        "date-max": "2026-12-31",
        "dist-max": "0.2",
        "sort": "date",
        "diameter": "true"
      },
      "expectedResponseType": "json",
      "sourceRecordHash": "fnv1a32-ba0c45bb",
      "workOrderId": "source-ingest-cad-api",
      "workOrderHash": "sha256-ae487ba413cc055f5780b588f01397328e6b175869437d23576aad46b9b9ce71",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "close-approach-logistics-screen",
        "requiredFields": [
          "des",
          "cd",
          "dist",
          "v_rel",
          "h",
          "diameter"
        ],
        "blockedIfMissing": [
          "field metadata",
          "date window",
          "distance threshold",
          "row-level hash"
        ]
      },
      "unitsMap": {
        "closeApproachDate": "UTC date/time string from provider",
        "nominalDistance": "AU",
        "relativeVelocity": "km/s",
        "diameter": "km or m if available"
      },
      "uncertaintyMap": {
        "closeApproachFrequency": "Depends on query window and orbit solution.",
        "relativeVelocity": "Nominal provider value; candidate promotion needs object-level review.",
        "diameter": "Unknown or source-stated uncertainty."
      },
      "licenseOrTermsNote": "NASA/JPL CNEOS public API; rows must be normalized and hashed before use in candidate promotion.",
      "fixtureOrTolerancePlan": "Validate that CAD rows are treated as logistics signals and not as resource evidence.",
      "promotionBoundary": "Close-approach signal only; does not prove availability, accessibility, ownership, composition, or mission feasibility.",
      "rateLimitOrAccessNote": "Use deterministic snapshots for app runtime; live refresh generates review candidates.",
      "queryHash": "sha256-e1dd6bf53bf1f8deedd1eca765ca58f8d04ae1cc2dcbd2fc7cc60efe3af8258d",
      "recordHash": "sha256-e24f3ecd6b40f52ed1ad7b4976522a1aed92b97c00705f1c3996a17262e19006"
    },
    {
      "id": "query-mpc-observation-bridge",
      "sourceId": "mpc",
      "sourceTitle": "Minor Planet Center Data",
      "provider": "IAU Minor Planet Center",
      "endpoint": "https://minorplanetcenter.net/data",
      "method": "GET",
      "params": {
        "designation": "candidate-specific",
        "product": "observation-or-designation-record",
        "retrievalWindow": "reviewed-batch"
      },
      "expectedResponseType": "catalog-or-observation-file",
      "sourceRecordHash": "fnv1a32-62694497",
      "workOrderId": "source-ingest-mpc",
      "workOrderHash": "sha256-6f4ec4d25fd364055d8c199c2c900fb140fcfd4c471ff4343dd8cb45ab928bc7",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "candidate-observation-bridge",
        "requiredFields": [
          "designation",
          "observationTime",
          "observatoryCode",
          "astrometryRecord"
        ],
        "blockedIfMissing": [
          "object designation bridge",
          "retrieval timestamp",
          "observation batch hash"
        ]
      },
      "unitsMap": {
        "observationTime": "MPC packed or ISO time after parser normalization",
        "astrometry": "RA/Dec and residual fields as provider states",
        "observatoryCode": "MPC observatory code"
      },
      "uncertaintyMap": {
        "observationResiduals": "Retain provider residuals or mark unknown.",
        "orbitBridge": "Must be reconciled to SBDB/CAD candidate identity."
      },
      "licenseOrTermsNote": "MPC data terms must be reviewed before redistribution; this record only defines custody requirements.",
      "fixtureOrTolerancePlan": "Confirm candidate designation maps to SBDB/CAD record without silently merging distinct objects.",
      "promotionBoundary": "Observation bridge only; no resource, trajectory, or economics promotion.",
      "rateLimitOrAccessNote": "Prefer reviewed batch pulls and source-file hashes.",
      "queryHash": "sha256-387e10e01e3f5b19f29546804413e2a450f266c3c66b543967dd81ed58a9092f",
      "recordHash": "sha256-192a088a7929e9123593ea06abc0fabd0007446231c537089f30cee542261ee6"
    },
    {
      "id": "query-nist-codata-constants",
      "sourceId": "nist-codata",
      "sourceTitle": "2022 CODATA Fundamental Physical Constants",
      "provider": "NIST",
      "endpoint": "https://physics.nist.gov/cuu/Constants/Table/allascii.txt",
      "method": "GET",
      "params": {
        "release": "CODATA 2022",
        "constants": [
          "speed of light in vacuum",
          "Stefan-Boltzmann constant",
          "astronomical unit"
        ]
      },
      "expectedResponseType": "plain-text-constants-table",
      "sourceRecordHash": "fnv1a32-333cff52",
      "workOrderId": "source-ingest-nist-codata",
      "workOrderHash": "sha256-5c1b9ed4354c988060da39a5fd86d1e0758fc9b447ffff3389a35c5862d4f85d",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "physical-constant-record",
        "requiredFields": [
          "constantName",
          "value",
          "unit",
          "uncertaintyOrExact"
        ],
        "blockedIfMissing": [
          "release label",
          "unit",
          "exactness or uncertainty"
        ]
      },
      "unitsMap": {
        "speedOfLight": "m/s",
        "stefanBoltzmann": "W m^-2 K^-4",
        "astronomicalUnit": "m or km after exact conversion"
      },
      "uncertaintyMap": {
        "speedOfLight": "Exact SI value.",
        "stefanBoltzmann": "CODATA uncertainty or release note.",
        "astronomicalUnit": "IAU exact astronomical unit; conversion must be explicit."
      },
      "licenseOrTermsNote": "NIST constants are public reference data; exact release and retrieval hash still required.",
      "fixtureOrTolerancePlan": "Re-run kernel formula tests for light-time, irradiance, and thermal estimates after any constant refresh.",
      "promotionBoundary": "Formula-input custody only; does not promote scenario conclusions without linked model tests.",
      "rateLimitOrAccessNote": "Low-frequency refresh tied to CODATA or standards updates.",
      "queryHash": "sha256-0acb84eee7b7947a848daeedce840608fe9faa1dfaae8b1eb21ae1cbb1bc28be",
      "recordHash": "sha256-52e2c25e4f2ac496f9cd7d8ab9b4f5ed126213514fdf6fce711057790f7f10d7"
    },
    {
      "id": "query-pds-messenger-product-search",
      "sourceId": "pds",
      "sourceTitle": "Planetary Data System",
      "provider": "NASA Planetary Data System",
      "endpoint": "https://pds.nasa.gov/datasearch/data-search/",
      "method": "GET",
      "params": {
        "mission": "MESSENGER",
        "target": "Mercury",
        "productType": "instrument-specific",
        "productId": "reviewed-product-id-required"
      },
      "expectedResponseType": "archive-search-result-or-product-label",
      "sourceRecordHash": "fnv1a32-7c477cc2",
      "workOrderId": "source-ingest-pds",
      "workOrderHash": "sha256-928a0c47b33ef9948c19972c1b4ecf480cf557b36aad1191673dce710ab29a11",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "mission-product-evidence-record",
        "requiredFields": [
          "bundle",
          "collection",
          "productId",
          "instrument",
          "calibrationStatus",
          "citation"
        ],
        "blockedIfMissing": [
          "product id",
          "calibration metadata",
          "instrument context",
          "citation"
        ]
      },
      "unitsMap": {
        "productData": "instrument-specific",
        "target": "IAU target name",
        "observationTime": "product label time field"
      },
      "uncertaintyMap": {
        "calibration": "Product calibration and instrument uncertainty metadata.",
        "spatialCoverage": "Product footprint or unknown."
      },
      "licenseOrTermsNote": "PDS product citation and archive terms must travel with any mission-data derived claim.",
      "fixtureOrTolerancePlan": "Resource or surface-environment claims remain blocked until product labels and calibration metadata are reviewed.",
      "promotionBoundary": "Mission-data lookup custody only; no surface resource or process-fit claim.",
      "rateLimitOrAccessNote": "Use reviewed product lists and persistent identifiers.",
      "queryHash": "sha256-fbe8eab083a4bb3d2a1cfa7e1ad1989f439a374cd5ebb404483dbbec11d7ec1d",
      "recordHash": "sha256-36ce2feb9fcb1cc8b62edd27164c85762f981f21ad0fb0a92f8761b478964527"
    },
    {
      "id": "query-spdf-space-environment-dataset",
      "sourceId": "nasa-spdf",
      "sourceTitle": "NASA Space Physics Data Facility",
      "provider": "NASA SPDF/CDAWeb",
      "endpoint": "https://cdaweb.gsfc.nasa.gov/",
      "method": "GET",
      "params": {
        "datasetId": "reviewed-dataset-id-required",
        "variables": [
          "radiation-or-plasma-variable-required"
        ],
        "start": "scenario-window-start",
        "stop": "scenario-window-stop",
        "cadence": "declared"
      },
      "expectedResponseType": "cdf-or-service-result",
      "sourceRecordHash": "fnv1a32-05f4400c",
      "workOrderId": "source-ingest-nasa-spdf",
      "workOrderHash": "sha256-51d99b5f2da48846e8e4a77b621cb62ef65414de2e99c0a5eac3dd87bad87621",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "space-environment-time-series",
        "requiredFields": [
          "datasetId",
          "variables",
          "timeRange",
          "cadence",
          "units",
          "archiveVersion"
        ],
        "blockedIfMissing": [
          "dataset citation",
          "variable units",
          "time range",
          "quality flags"
        ]
      },
      "unitsMap": {
        "time": "UTC or TT as source declares",
        "plasmaRadiationVariables": "dataset-specific physical units",
        "cadence": "seconds or source-declared interval"
      },
      "uncertaintyMap": {
        "instrument": "Calibration/quality flags retained.",
        "coverage": "Missing-data windows retained."
      },
      "licenseOrTermsNote": "NASA SPDF archive citation and dataset metadata must be preserved before hazard-model promotion.",
      "fixtureOrTolerancePlan": "Environment scores must show missing data and cannot become single-point certainty metrics.",
      "promotionBoundary": "Environment input custody only; no operational hazard forecast.",
      "rateLimitOrAccessNote": "Pull bounded windows into reviewed artifacts; browser consumes cached outputs.",
      "queryHash": "sha256-d5012da7738299865f5fd910c029b41bb7331c5394c8d8fc2f115afe53366302",
      "recordHash": "sha256-529be87464eaf7f44924ad1de45c37af1f58b9afa6f367f8c4aaf21fa344d64b"
    },
    {
      "id": "query-materials-project-property-record",
      "sourceId": "materials-project",
      "sourceTitle": "Materials Project API",
      "provider": "Materials Project",
      "endpoint": "https://api.materialsproject.org/",
      "method": "GET",
      "params": {
        "materialIds": [
          "mp-id-required"
        ],
        "fields": [
          "formula_pretty",
          "density",
          "energy_above_hull",
          "band_gap",
          "thermo",
          "summary"
        ],
        "apiVersion": "recorded-client-version-required"
      },
      "expectedResponseType": "json",
      "sourceRecordHash": "fnv1a32-c46b2daa",
      "workOrderId": "source-ingest-materials-project",
      "workOrderHash": "sha256-cf340e050bde6a9a086fea668420d741780db2d71381b6b8de0222967e39b600",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "material-property-record",
        "requiredFields": [
          "materialId",
          "formula",
          "density",
          "method",
          "provenance",
          "retrievedAt"
        ],
        "blockedIfMissing": [
          "API version",
          "method/provenance",
          "field list",
          "license review"
        ]
      },
      "unitsMap": {
        "density": "g/cm^3",
        "energyAboveHull": "eV/atom",
        "bandGap": "eV",
        "formationEnergy": "eV/atom"
      },
      "uncertaintyMap": {
        "method": "DFT/method limitation, functional, and contributed-data caveats.",
        "applicability": "Manufacturing/process assumptions require separate lab or literature evidence."
      },
      "licenseOrTermsNote": "Materials Project API key, citation, and redistribution terms must be reviewed before storing raw records.",
      "fixtureOrTolerancePlan": "Process-fit scoring can consume reviewed material properties only with method caveats and source hash.",
      "promotionBoundary": "Material property custody only; no manufacturability or economic claim by itself.",
      "rateLimitOrAccessNote": "Requires authenticated API use outside browser runtime; cache reviewed outputs.",
      "queryHash": "sha256-51d4f543e148cedae176705c8829ff3da1ab7f4b53a239ff6c78de2c82b447be",
      "recordHash": "sha256-a2b3422b1d23495e140cfd7322d6bd73571067a49ebb3afafaa64c20b4ba9553"
    },
    {
      "id": "query-cantera-registry-custody",
      "sourceId": "cantera",
      "sourceTitle": "Cantera",
      "provider": "Cantera project",
      "endpoint": "https://cantera.org/",
      "method": "GET",
      "params": {
        "sourceId": "cantera",
        "sourceType": "chemistry-transport-toolkit",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Mechanism file, tool version, inputs, outputs, and mechanism hash required.",
        "sourceUrl": "https://cantera.org/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "versioned-documentation-or-runtime-artifact",
      "sourceRecordHash": "fnv1a32-883bdb34",
      "workOrderId": "source-ingest-cantera",
      "workOrderHash": "sha256-db1a361118b0599a32f646adbfd56174b3632166b2e0ecee2f1a8033a365161b",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "materials-process-source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "species",
        "declaredUnit2": "reactions",
        "declaredUnit3": "transport",
        "declaredUnit4": "temperature",
        "declaredUnit5": "pressure"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Mechanism validity range and solver tolerance.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-0544eed41f30b94f0a5881158adad8c7116ff56c228e3c93d14703ba12a29f48",
      "recordHash": "sha256-7b7de323acf175bc82934096fc61f84769903225591315b76f256c65ddee3a12"
    },
    {
      "id": "query-ccsds-registry-custody",
      "sourceId": "ccsds",
      "sourceTitle": "Consultative Committee for Space Data Systems",
      "provider": "CCSDS member agencies",
      "endpoint": "https://ccsds.org/",
      "method": "GET",
      "params": {
        "sourceId": "ccsds",
        "sourceType": "space-data-standard",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Publication id, version, area, and applied assumption required.",
        "sourceUrl": "https://ccsds.org/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "official-document-or-versioned-web-record",
      "sourceRecordHash": "fnv1a32-75fdfe19",
      "workOrderId": "source-ingest-ccsds",
      "workOrderHash": "sha256-b2385bd497c44bdeeba3f2a42c96aea3d91e0a695fe68cc6558aed05260714bf",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "communications-standard-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "standard-specific"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Standards conformance caveats and mission-specific implementation deltas.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-96888191bbaf772a735fcabfef40180db1031713bc3970ac775ce610bb14ef73",
      "recordHash": "sha256-801c9818391de052b08eacfa1a39fd51d9ab75faf4febbaad56a2c995bb0ae62"
    },
    {
      "id": "query-dymos-registry-custody",
      "sourceId": "dymos",
      "sourceTitle": "Dymos",
      "provider": "OpenMDAO project",
      "endpoint": "https://openmdao.github.io/dymos/",
      "method": "GET",
      "params": {
        "sourceId": "dymos",
        "sourceType": "optimal-control-library",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Problem definition, transcription, optimizer, constraints, objective, and run seed required.",
        "sourceUrl": "https://openmdao.github.io/dymos/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "versioned-documentation-or-runtime-artifact",
      "sourceRecordHash": "fnv1a32-31dbd31c",
      "workOrderId": "source-ingest-dymos",
      "workOrderHash": "sha256-5f0c857d5f01ab9369fac47f0b965676cd1d5551ba22f91f1294e64872c344d0",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "runtime-tool-or-methodology-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "states",
        "declaredUnit2": "controls",
        "declaredUnit3": "constraints",
        "declaredUnit4": "objective values"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Convergence status, sensitivity, and collocation residuals.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-7482084ae72b7b881915b97e7866a829c3a9e1933bd0abf978ca626568092f71",
      "recordHash": "sha256-2440667c0ecf83f91ab7dfd8c26e0b811309d5f1a37372dc615b28a80cd80b86"
    },
    {
      "id": "query-esa-psa-registry-custody",
      "sourceId": "esa-psa",
      "sourceTitle": "ESA Planetary Science Archive",
      "provider": "European Space Agency",
      "endpoint": "https://archives.esac.esa.int/psa/",
      "method": "GET",
      "params": {
        "sourceId": "esa-psa",
        "sourceType": "planetary-mission-archive",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Mission, instrument, product id, citation, and license/use terms required.",
        "sourceUrl": "https://archives.esac.esa.int/psa/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "structured-record-or-bounded-source-file",
      "sourceRecordHash": "fnv1a32-5c0abe4d",
      "workOrderId": "source-ingest-esa-psa",
      "workOrderHash": "sha256-e943bde41a94f1789b36698e84beaf971e81fece7b2e6162591edfd8afdad615",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "archive-product-or-observation-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "mission/product-specific"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Product calibration, processing level, and instrument caveats.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-bd033f065f2c56715159b5b02f5b60a48127345c50d258a2ee4a0426485b945d",
      "recordHash": "sha256-ec45a5d5a42e831ed6d658b24de0371695e6e67ad05be9b7d6e1aef4bc83fcdc"
    },
    {
      "id": "query-gmat-registry-custody",
      "sourceId": "gmat",
      "sourceTitle": "General Mission Analysis Tool",
      "provider": "NASA",
      "endpoint": "https://software.nasa.gov/software/GSC-17177-1",
      "method": "GET",
      "params": {
        "sourceId": "gmat",
        "sourceType": "mission-analysis-tool",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "GMAT script hash, version, force model, optimizer, and run summary required.",
        "sourceUrl": "https://software.nasa.gov/software/GSC-17177-1",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "versioned-documentation-or-runtime-artifact",
      "sourceRecordHash": "fnv1a32-3743e565",
      "workOrderId": "source-ingest-gmat",
      "workOrderHash": "sha256-9dc7bf9fb79de628782cf8b0323b4f3813914992b426fe4dc7a3daf3eae8833d",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "runtime-tool-or-methodology-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "km",
        "declaredUnit2": "km/s",
        "declaredUnit3": "seconds",
        "declaredUnit4": "constraints"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Constraint residuals and cross-tool comparison.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-8c0470aba1f0efa5938d8513c4117028fd4bebaf74592944f643ddfe29c65f50",
      "recordHash": "sha256-581f94654502311175ca60843af4b4e4327c250cbd53e336f7dace7eab5d63e6"
    },
    {
      "id": "query-horizons-mercury-2024-registry-custody",
      "sourceId": "horizons-mercury-2024",
      "sourceTitle": "JPL Horizons Mercury Physical Data",
      "provider": "NASA/JPL Horizons",
      "endpoint": "https://ssd.jpl.nasa.gov/api/horizons.api?format=json&COMMAND=%27199%27&OBJ_DATA=%27YES%27&MAKE_EPHEM=%27NO%27",
      "method": "GET",
      "params": {
        "sourceId": "horizons-mercury-2024",
        "sourceType": "body-physical-data",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Body-data query and retrieved physical constants required.",
        "sourceUrl": "https://ssd.jpl.nasa.gov/api/horizons.api?format=json&COMMAND=%27199%27&OBJ_DATA=%27YES%27&MAKE_EPHEM=%27NO%27",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "reviewed-source-record",
      "sourceRecordHash": "fnv1a32-5b941f40",
      "workOrderId": "source-ingest-horizons-mercury-2024",
      "workOrderHash": "sha256-e7d428df65ab7cdaf3a65ff87baef2566e262a1959f270ef265ea8d5963853d8",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "days",
        "declaredUnit2": "AU",
        "declaredUnit3": "W/m^2"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Source-body data plus formula tolerance.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-1d623b814aa2a966ddd0b76d4b180ac50741791bb9cc13f4e42e501c4e97082b",
      "recordHash": "sha256-6677e2c6b5bedbed2dedd86d62a802071ce1ec8df175a2924ec2cf0a454e6dea"
    },
    {
      "id": "query-iau-sofa-registry-custody",
      "sourceId": "iau-sofa",
      "sourceTitle": "Standards of Fundamental Astronomy",
      "provider": "IAU SOFA",
      "endpoint": "https://www.iausofa.org/",
      "method": "GET",
      "params": {
        "sourceId": "iau-sofa",
        "sourceType": "astronomy-standards",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Routine/version reference and transformation chain required.",
        "sourceUrl": "https://www.iausofa.org/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "official-document-or-versioned-web-record",
      "sourceRecordHash": "fnv1a32-2a854c84",
      "workOrderId": "source-ingest-iau-sofa",
      "workOrderHash": "sha256-4e64bcced35d7a9497724400b98fb6e2a86515ae74b1c7048f63bbad8b99f06e",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "time scales",
        "declaredUnit2": "reference frames"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Standards conformance and transform precision.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-a705fb8d269a210043ba9f7e1dc03457a59a7ed1f5b4e6b479c9c38fb5dd8b0c",
      "recordHash": "sha256-d60400cf060cdbed3fb49bac9bca985de2ec293673576826d0535784ab0ba14d"
    },
    {
      "id": "query-jaxa-darts-registry-custody",
      "sourceId": "jaxa-darts",
      "sourceTitle": "DARTS Space Science Data Archive",
      "provider": "ISAS/JAXA",
      "endpoint": "https://darts.isas.jaxa.jp/",
      "method": "GET",
      "params": {
        "sourceId": "jaxa-darts",
        "sourceType": "space-science-archive",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Mission, dataset, product id, retrieval timestamp, and citation required.",
        "sourceUrl": "https://darts.isas.jaxa.jp/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "structured-record-or-bounded-source-file",
      "sourceRecordHash": "fnv1a32-e07b656d",
      "workOrderId": "source-ingest-jaxa-darts",
      "workOrderHash": "sha256-a4b69d55b7d4cc9a233b493a92ff3e8497fcf65a45bf8e332e389d21af096fb2",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "archive-product-or-observation-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "mission/product-specific"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Dataset calibration and archive release notes.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-2e1b18587988d3ce23fa54593b4b2d8d811eeb8c967fc55935ee40fa07e2be72",
      "recordHash": "sha256-a1ff6e4a22e29bf1dbdc82ed05e1e85f166ec11e810931a62ec93722cc542e96"
    },
    {
      "id": "query-moose-framework-registry-custody",
      "sourceId": "moose-framework",
      "sourceTitle": "MOOSE Framework",
      "provider": "Idaho National Laboratory",
      "endpoint": "https://mooseframework.inl.gov/",
      "method": "GET",
      "params": {
        "sourceId": "moose-framework",
        "sourceType": "multiphysics-framework",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Input file, application/version, mesh hash, material data, and output hash required.",
        "sourceUrl": "https://mooseframework.inl.gov/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "versioned-documentation-or-runtime-artifact",
      "sourceRecordHash": "fnv1a32-a9482599",
      "workOrderId": "source-ingest-moose-framework",
      "workOrderHash": "sha256-f78f596ae140aade5b7d0fd53aa491e4a0478dca93cf5ea1c391bfe57ba93d7a",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "materials-process-source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "mesh",
        "declaredUnit2": "material properties",
        "declaredUnit3": "PDE residuals",
        "declaredUnit4": "solver tolerances"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Discretization, mesh convergence, solver residuals, and material uncertainty.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-1906feb8d1d2a8bfbbf1295fc5aa640e99dfeae7f6d39f507334ad119f139cab",
      "recordHash": "sha256-a60aedd275a59e7e1c7be4f448747b95e964e81196f0a7cf4998387b0cfc9315"
    },
    {
      "id": "query-nasa-ccmc-registry-custody",
      "sourceId": "nasa-ccmc",
      "sourceTitle": "Community Coordinated Modeling Center",
      "provider": "NASA Goddard",
      "endpoint": "https://ccmc.gsfc.nasa.gov/",
      "method": "GET",
      "params": {
        "sourceId": "nasa-ccmc",
        "sourceType": "space-weather-modeling-center",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Model, run id, inputs, version, and output hash required.",
        "sourceUrl": "https://ccmc.gsfc.nasa.gov/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "reviewed-source-record",
      "sourceRecordHash": "fnv1a32-1a450de5",
      "workOrderId": "source-ingest-nasa-ccmc",
      "workOrderHash": "sha256-5c43fc31587c76573078911a506a40bae0680e9cedff867363f70cf7bc301d6e",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "space-environment-source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "model-specific"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Model validation state, run configuration, and uncertainty bounds.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-79a0b5653716638312fe893aff8407fc20852add7b1970daaaf8f96f4ec3181e",
      "recordHash": "sha256-be6685ce7956ca8d30ede9a43e6986ce51b3d4d064554abc127fee8effb55e1b"
    },
    {
      "id": "query-nasa-clps-registry-custody",
      "sourceId": "nasa-clps",
      "sourceTitle": "Commercial Lunar Payload Services",
      "provider": "NASA",
      "endpoint": "https://www.nasa.gov/commercial-lunar-payload-services/",
      "method": "GET",
      "params": {
        "sourceId": "nasa-clps",
        "sourceType": "commercial-lunar-delivery-program",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Capture NASA program page, date, task-order references, provider, payload mass/context, and award amount where available.",
        "sourceUrl": "https://www.nasa.gov/commercial-lunar-payload-services/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "official-document-or-versioned-web-record",
      "sourceRecordHash": "fnv1a32-7d151be6",
      "workOrderId": "source-ingest-nasa-clps",
      "workOrderHash": "sha256-103b2187a271bdebfe18b355f043669ad9fec03243cedf0839aebc8c289670b2",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "dated-economics-source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "USD",
        "declaredUnit2": "payload count",
        "declaredUnit3": "delivery count",
        "declaredUnit4": "contract envelope"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Task-order scope, modifications, mission risk, provider performance, and payload-specific services.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-be84a795718f8a966ee66cdfa9f5ad84849dddc6fc6668ff773da4442985fc8d",
      "recordHash": "sha256-a84314ca97bdafd394ce54bdd9f5aa2ba91773d725677b37b55b69e7052d7d63"
    },
    {
      "id": "query-nasa-cost-estimating-handbook-registry-custody",
      "sourceId": "nasa-cost-estimating-handbook",
      "sourceTitle": "NASA Cost Estimating Handbook",
      "provider": "NASA",
      "endpoint": "https://www.nasa.gov/reference/nasa-cost-estimating-handbook/",
      "method": "GET",
      "params": {
        "sourceId": "nasa-cost-estimating-handbook",
        "sourceType": "cost-estimating-methodology",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Document handbook version, estimating method, normalization year, risk treatment, and applied model assumptions.",
        "sourceUrl": "https://www.nasa.gov/reference/nasa-cost-estimating-handbook/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "official-document-or-versioned-web-record",
      "sourceRecordHash": "fnv1a32-a82e1046",
      "workOrderId": "source-ingest-nasa-cost-estimating-handbook",
      "workOrderHash": "sha256-f74bd3fc758ddea4d2670ac38bd556db89c2345ac4aa833a8f9e9b5388747030",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "dated-economics-source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "cost estimate classes",
        "declaredUnit2": "risk",
        "declaredUnit3": "schedule",
        "declaredUnit4": "uncertainty"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Method selection, analogy quality, learning curves, schedule risk, and normalization assumptions.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-320b21170eecde0ed8c1198691bea72e58a49ffa58d6955f87c232a19915e1ae",
      "recordHash": "sha256-457a4bee6ecdb3e6437e6118d03e88b18f0a318c33f0b5c050aa1cb7ec9542c1"
    },
    {
      "id": "query-nasa-dtn-registry-custody",
      "sourceId": "nasa-dtn",
      "sourceTitle": "Delay/Disruption Tolerant Networking",
      "provider": "NASA SCaN",
      "endpoint": "https://www.nasa.gov/communicating-with-missions/delay-disruption-tolerant-networking/",
      "method": "GET",
      "params": {
        "sourceId": "nasa-dtn",
        "sourceType": "communications-program-reference",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Program reference, architecture assumption, and scenario mapping required.",
        "sourceUrl": "https://www.nasa.gov/communicating-with-missions/delay-disruption-tolerant-networking/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "official-document-or-versioned-web-record",
      "sourceRecordHash": "fnv1a32-61e03fe6",
      "workOrderId": "source-ingest-nasa-dtn",
      "workOrderHash": "sha256-b3d7fd849f5c4e594460d082a7508d2df2190a6f72324f33faf3865c2f8f1bd4",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "communications-standard-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "protocol concepts",
        "declaredUnit2": "network behavior"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Conceptual architecture until mission-specific link data exists.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-2f1f0d0a9030449096e5e63aca0015e6a6afc25fa43bb893452ea89e9b4f3b93",
      "recordHash": "sha256-c67f16763ceadf91805b28e45b0905aa85d11ad775f6c2b59c81bbcefdb738db"
    },
    {
      "id": "query-nasa-mercury-registry-custody",
      "sourceId": "nasa-mercury",
      "sourceTitle": "Mercury Facts",
      "provider": "NASA Science",
      "endpoint": "https://science.nasa.gov/mercury/facts/",
      "method": "GET",
      "params": {
        "sourceId": "nasa-mercury",
        "sourceType": "official-factsheet",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Page URL, access date, and derived-calculation trace required.",
        "sourceUrl": "https://science.nasa.gov/mercury/facts/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "official-document-or-versioned-web-record",
      "sourceRecordHash": "fnv1a32-78229f8d",
      "workOrderId": "source-ingest-nasa-mercury",
      "workOrderHash": "sha256-5b53cd471db10365d2e0a9126eb6fd841ddbed0292a6202d9865d5c32e634bb3",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "AU",
        "declaredUnit2": "days",
        "declaredUnit3": "K",
        "declaredUnit4": "W/m^2 context"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Factsheet summary caveats; not a substitute for mission data.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-906f7cf65949b0c887473e613355664ff613d48f1f5c20c057163526bde61e91",
      "recordHash": "sha256-abd599e40d386d20b5f3612ebb68edd6d26802bb1d8b2c5fa6efefd455d862f6"
    },
    {
      "id": "query-nasa-se-handbook-registry-custody",
      "sourceId": "nasa-se-handbook",
      "sourceTitle": "NASA Systems Engineering Handbook",
      "provider": "NASA",
      "endpoint": "https://www.nasa.gov/reference/systems-engineering-handbook/",
      "method": "GET",
      "params": {
        "sourceId": "nasa-se-handbook",
        "sourceType": "systems-engineering-methodology",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Document handbook version, review/maturity concept used, and mapping to scenario/process gates.",
        "sourceUrl": "https://www.nasa.gov/reference/systems-engineering-handbook/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "official-document-or-versioned-web-record",
      "sourceRecordHash": "fnv1a32-991637e4",
      "workOrderId": "source-ingest-nasa-se-handbook",
      "workOrderHash": "sha256-5487d37dfcb0839e0a74edc36e4c42421e60c5a9dcd0b29821e7c0eac564757e",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "life-cycle phase",
        "declaredUnit2": "maturity",
        "declaredUnit3": "verification",
        "declaredUnit4": "validation"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Program-specific tailoring and maturity-assessment subjectivity.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-2155d17a72750435bedf2124328b39085776be6dbca77aae8b1722f571f45bef",
      "recordHash": "sha256-d880c12ae29a86c616385686f5b15a7faf1763b16303bcb7cb135b1c58d977ec"
    },
    {
      "id": "query-nist-chemistry-webbook-registry-custody",
      "sourceId": "nist-chemistry-webbook",
      "sourceTitle": "NIST Chemistry WebBook SRD 69",
      "provider": "NIST",
      "endpoint": "https://webbook.nist.gov/chemistry/",
      "method": "GET",
      "params": {
        "sourceId": "nist-chemistry-webbook",
        "sourceType": "chemistry-reference-database",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Species identifier, property table, units, citation, and access date required.",
        "sourceUrl": "https://webbook.nist.gov/chemistry/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "structured-record-or-bounded-source-file",
      "sourceRecordHash": "fnv1a32-d9ac987b",
      "workOrderId": "source-ingest-nist-chemistry-webbook",
      "workOrderHash": "sha256-c8ff016cbc8ee86304a0027a3a4bf3b954b1853a379196d071531f86800f2c3d",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "materials-process-source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "thermochemical",
        "declaredUnit2": "thermophysical",
        "declaredUnit3": "spectral"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "NIST data notes, property method, and cited evaluation caveats.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-ec5f27052c18b383bfc63840b301307c1e8b109fa3086825842ff1c55630e0f2",
      "recordHash": "sha256-767ace254a3834bdc93cd8819c6e7fa3d4ee8a0c92407915311c4fd673f1f65c"
    },
    {
      "id": "query-noaa-swpc-registry-custody",
      "sourceId": "noaa-swpc",
      "sourceTitle": "NOAA Space Weather Prediction Center Products and Data",
      "provider": "NOAA/NWS",
      "endpoint": "https://www.spaceweather.gov/products-and-data",
      "method": "GET",
      "params": {
        "sourceId": "noaa-swpc",
        "sourceType": "space-weather-products",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Product id, issue time, forecast horizon, and archive link required.",
        "sourceUrl": "https://www.spaceweather.gov/products-and-data",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "structured-record-or-bounded-source-file",
      "sourceRecordHash": "fnv1a32-dbbbdd09",
      "workOrderId": "source-ingest-noaa-swpc",
      "workOrderHash": "sha256-81ed94a99ffe23584f88770cc74cf7baf37c0aff4cf678a1f45a9a570c740bab",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "space-environment-source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "Kp",
        "declaredUnit2": "Ap",
        "declaredUnit3": "F10.7",
        "declaredUnit4": "particle flux",
        "declaredUnit5": "alerts"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Forecast horizon and product-specific verification notes.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-07c7a140cbccdf2e299ce7f2d429c612453aa3837cd3972f2364bc70a569a9a0",
      "recordHash": "sha256-f59a123e66de5ea5d5988d99b8458a3cad0051b0be5e9f349ea1b63302c42936"
    },
    {
      "id": "query-openfoam-registry-custody",
      "sourceId": "openfoam",
      "sourceTitle": "OpenFOAM",
      "provider": "OpenCFD / OpenFOAM community",
      "endpoint": "https://www.openfoam.com/",
      "method": "GET",
      "params": {
        "sourceId": "openfoam",
        "sourceType": "cfd-toolkit",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Case directory hash, solver/version, mesh, boundary conditions, and result hash required.",
        "sourceUrl": "https://www.openfoam.com/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "versioned-documentation-or-runtime-artifact",
      "sourceRecordHash": "fnv1a32-124056ab",
      "workOrderId": "source-ingest-openfoam",
      "workOrderHash": "sha256-566ae59e4e0f9d4741dfcaa81bce5623888a62582eb0729763f3dcc1953094e7",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "materials-process-source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "mesh",
        "declaredUnit2": "fields",
        "declaredUnit3": "boundary conditions",
        "declaredUnit4": "solver residuals"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Mesh convergence, turbulence model, chemistry model, and boundary-condition uncertainty.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-be48cd7dbc1082da909e0093228c37d2f29421fd47236fa91525a4962c2be120",
      "recordHash": "sha256-511bc80f7dcbbe14d68c752e50bb4839c51de9ca5f68d84d10dedc49325fe29a"
    },
    {
      "id": "query-openmdao-registry-custody",
      "sourceId": "openmdao",
      "sourceTitle": "OpenMDAO",
      "provider": "NASA",
      "endpoint": "https://openmdao.org/",
      "method": "GET",
      "params": {
        "sourceId": "openmdao",
        "sourceType": "optimization-framework",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Problem definition, design variables, constraints, objective, and seed required.",
        "sourceUrl": "https://openmdao.org/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "versioned-documentation-or-runtime-artifact",
      "sourceRecordHash": "fnv1a32-9ef7d3cb",
      "workOrderId": "source-ingest-openmdao",
      "workOrderHash": "sha256-c6f5e90eb17541785cd427c2bbd3aa01691aca58bd56e984e39f91c732f1a20b",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "runtime-tool-or-methodology-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "dimensionless",
        "declaredUnit2": "scenario-specific"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Sensitivity and optimizer-convergence metadata.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-de542983ecf6803f8508a973a05368bb577bbf9269b60df9ab3cec62911749f8",
      "recordHash": "sha256-3a9cd901f38c2a0349672cf1a0e94307ee285f84f43175f291629f30616ab8a3"
    },
    {
      "id": "query-orekit-registry-custody",
      "sourceId": "orekit",
      "sourceTitle": "Orekit",
      "provider": "CS Group / open source community",
      "endpoint": "https://www.orekit.org/",
      "method": "GET",
      "params": {
        "sourceId": "orekit",
        "sourceType": "astrodynamics-library",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Tool version, data context, frames, force model, and checksums required.",
        "sourceUrl": "https://www.orekit.org/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "versioned-documentation-or-runtime-artifact",
      "sourceRecordHash": "fnv1a32-88a8d672",
      "workOrderId": "source-ingest-orekit",
      "workOrderHash": "sha256-32e680e406eeddf3facdf231b3f530178321968183591cbb59f8a4f88d12eec3",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "runtime-tool-or-methodology-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "frames",
        "declaredUnit2": "time scales",
        "declaredUnit3": "state vectors",
        "declaredUnit4": "events"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Model configuration and independent comparison residuals.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-640b0ea9a67ab695a4474da2597d851641ddc776f1e3108d188e946499c7a39c",
      "recordHash": "sha256-2a4d89d52d78b5493183020fa556a769afd6f2ee339a954fba20aa895b5e8d18"
    },
    {
      "id": "query-sec-edgar-registry-custody",
      "sourceId": "sec-edgar",
      "sourceTitle": "SEC EDGAR",
      "provider": "U.S. Securities and Exchange Commission",
      "endpoint": "https://www.sec.gov/edgar",
      "method": "GET",
      "params": {
        "sourceId": "sec-edgar",
        "sourceType": "public-company-filings",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Preserve CIK/ticker, accession number, filing date, statement section, XBRL fields, and retrieval hash.",
        "sourceUrl": "https://www.sec.gov/edgar",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "structured-record-or-bounded-source-file",
      "sourceRecordHash": "fnv1a32-f2e84204",
      "workOrderId": "source-ingest-sec-edgar",
      "workOrderHash": "sha256-2fbe443ab4a09bc99bc5cf31b7633c0adf9375136831a5935e1574e13cceb994",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "dated-economics-source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "USD",
        "declaredUnit2": "filing date",
        "declaredUnit3": "fiscal period",
        "declaredUnit4": "risk factors"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Company-specific accounting policy, segment allocation, forward-looking statements, and market-cycle caveats.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-e2af3b79fc591b99801741b7de2f60ff20059ad630a6216ec68f8eb6b34da569",
      "recordHash": "sha256-fb368af2aaf5d6a80e6665aad7ff4bd95e63074e3f3e6114576f215b49968591"
    },
    {
      "id": "query-spacex-rideshare-registry-custody",
      "sourceId": "spacex-rideshare",
      "sourceTitle": "SpaceX Rideshare Program",
      "provider": "SpaceX",
      "endpoint": "https://www.spacex.com/rideshare/",
      "method": "GET",
      "params": {
        "sourceId": "spacex-rideshare",
        "sourceType": "commercial-launch-pricing",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Capture provider page, access timestamp, price table text, destination/orbit class, and terms caveats before use.",
        "sourceUrl": "https://www.spacex.com/rideshare/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "official-document-or-versioned-web-record",
      "sourceRecordHash": "fnv1a32-86aacff8",
      "workOrderId": "source-ingest-spacex-rideshare",
      "workOrderHash": "sha256-5ce3bc9316083ce268f83af9f6cb2470d854f556faa2d1f528d2feddd975fb01",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "dated-economics-source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "USD",
        "declaredUnit2": "kg",
        "declaredUnit3": "orbit class",
        "declaredUnit4": "payload envelope"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Commercial list price caveats, mission-specific integration costs, schedule, destination, and contract terms.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-ede2431508c4a80e9858cf188781742e91a9a7d46a853403d65947ca39a4884f",
      "recordHash": "sha256-48945f6e227e7546400375e076bc74860d685e3c69a8438412507c08e04eca8d"
    },
    {
      "id": "query-spice-gf-registry-custody",
      "sourceId": "spice-gf",
      "sourceTitle": "SPICE Geometry Finder",
      "provider": "NASA NAIF",
      "endpoint": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html",
      "method": "GET",
      "params": {
        "sourceId": "spice-gf",
        "sourceType": "ephemeris-event-software",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Kernel set, target/observer/constraint, tolerance, and generated window hash required.",
        "sourceUrl": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "versioned-documentation-or-runtime-artifact",
      "sourceRecordHash": "fnv1a32-97d74c96",
      "workOrderId": "source-ingest-spice-gf",
      "workOrderHash": "sha256-067366bfd5d48f4d3ec03a31d3ff19007a6aa77d692b3741d5949721a6fb75b8",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "runtime-tool-or-methodology-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "TDB/ET",
        "declaredUnit2": "km",
        "declaredUnit3": "degrees",
        "declaredUnit4": "event windows"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Kernel coverage plus geometric tolerance.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-d900ecd0a5bb8d01922e2c03b7ccd375d9a58f089b6785b42166e7c86eb061c0",
      "recordHash": "sha256-2bcd5e66ddd8bac5f7df34be12218147ae4deb8e9287a5cdfe3f879a386edf59"
    },
    {
      "id": "query-tudat-registry-custody",
      "sourceId": "tudat",
      "sourceTitle": "Tudat Space / TudatPy",
      "provider": "TU Delft Astrodynamics Toolbox community",
      "endpoint": "https://docs.tudat.space/en/latest/",
      "method": "GET",
      "params": {
        "sourceId": "tudat",
        "sourceType": "astrodynamics-toolkit",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Tool version, body settings, integrator, propagator, and output hashes required.",
        "sourceUrl": "https://docs.tudat.space/en/latest/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "versioned-documentation-or-runtime-artifact",
      "sourceRecordHash": "fnv1a32-c238f1d2",
      "workOrderId": "source-ingest-tudat",
      "workOrderHash": "sha256-036f1a6704d95b5f93ff6bca5ea75a05e823e85cb50ec2048eda3a5267a33a1a",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "runtime-tool-or-methodology-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "state vectors",
        "declaredUnit2": "epochs",
        "declaredUnit3": "frames",
        "declaredUnit4": "residuals"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Integrator settings, model configuration, and cross-tool residual bounds.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-03a7901d761ce7a8a15f9d182b1c10a407d1de55dd8cf5c5592ae8bdeaacf4db",
      "recordHash": "sha256-7c11cedddf474c7df476d9632c700a06c4e8b3275488de008ef0e3b3acc7c31d"
    },
    {
      "id": "query-usaspending-registry-custody",
      "sourceId": "usaspending",
      "sourceTitle": "USAspending.gov",
      "provider": "U.S. Treasury / federal agencies",
      "endpoint": "https://www.usaspending.gov/",
      "method": "GET",
      "params": {
        "sourceId": "usaspending",
        "sourceType": "federal-award-database",
        "retrievalMode": "bounded-reviewed-custody-record",
        "requiredLocator": "Preserve query filters, award id, recipient, agency, obligation amounts, date range, and retrieval hash.",
        "sourceUrl": "https://www.usaspending.gov/",
        "capturedAt": "2026-06-19"
      },
      "expectedResponseType": "structured-record-or-bounded-source-file",
      "sourceRecordHash": "fnv1a32-fb43b155",
      "workOrderId": "source-ingest-usaspending",
      "workOrderHash": "sha256-118104b16dfcfdaa9710627d94ccf03c2720317e8420d1ab0299f99cba314823",
      "captureMode": "query-custody-no-live-fetch",
      "liveFetchState": "not-fetched-snapshot-first",
      "liveFetchAllowedUse": "A future live fetch may create a review candidate only. It cannot promote claims until raw payload hash, normalized hash, parser version, units, uncertainty, license review, tests, and reviewer approval pass.",
      "parserContract": {
        "normalizedOutput": "dated-economics-source-custody-record",
        "requiredFields": [
          "sourceId",
          "sourceUrl",
          "captureTimestamp",
          "rawPayloadHash",
          "normalizedRecordHash",
          "citation"
        ],
        "blockedIfMissing": [
          "license or terms review",
          "unit map",
          "uncertainty treatment",
          "fixture or tolerance test",
          "reviewer approval"
        ]
      },
      "unitsMap": {
        "declaredUnit1": "USD",
        "declaredUnit2": "award id",
        "declaredUnit3": "recipient",
        "declaredUnit4": "obligation",
        "declaredUnit5": "period of performance"
      },
      "uncertaintyMap": {
        "sourceUncertaintyMode": "Award modification timing, obligation versus outlay, scope classification, and recipient hierarchy.",
        "parserRequirement": "Retain source uncertainty directly where available; otherwise mark unknown and block claim promotion."
      },
      "licenseOrTermsNote": "Public/source terms, citation, and license review are required before any raw payload or normalized output can be redistributed or promoted.",
      "fixtureOrTolerancePlan": "Attach a source-specific parser fixture or tolerance test before this registry custody record can become a reviewed payload.",
      "promotionBoundary": "Registry-derived custody only; does not promote any science, engineering, resource, economics, or business claim without reviewed payload evidence.",
      "rateLimitOrAccessNote": "Use snapshot-first refresh into reviewed artifacts; browser runtime must consume cached outputs rather than live provider calls.",
      "queryHash": "sha256-cda0dd1c80bb59ddf30f6f202bf1af37a409d22eb358192c6f0e69c4e57d3b85",
      "recordHash": "sha256-51492edd421dd2c38bb5082f3b2d90456ac4a2831083e9ae3ae26adb9769d885"
    }
  ],
  "ledgerHash": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c"
}
;
